import { render } from "./Page.vue?vue&type=template&id=2bd06a8b"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=2bd06a8b&lang=scss"
script.render = render

export default script